import { atom } from 'jotai'

export const mobileMenuAtom = atom({ isVisible: false })
